import { useQuery } from '@tanstack/react-query'
import { firestoreService } from '../firestore'
import type { CreditCard } from '@shared/firebase/schema'

export const dashboardKeys = {
  stats:       ['dashboard', 'stats'] as const,
  growth:      ['dashboard', 'growth'] as const,
  activity:    ['dashboard', 'activity'] as const,
  recentCards: (limit: number) => ['dashboard', 'recent-cards', limit] as const,
}

export function useDashboardActivity() {
  return useQuery({
    queryKey: dashboardKeys.activity,
    queryFn: () => firestoreService.getRecentActivity(),
    staleTime: 5 * 60 * 1000,
  })
}

export function useDashboardGrowth() {
  return useQuery({
    queryKey: dashboardKeys.growth,
    queryFn: () => firestoreService.getDashboardGrowth(),
    staleTime: 5 * 60 * 1000,
  })
}

export function useDashboardStats() {
  return useQuery({
    queryKey: dashboardKeys.stats,
    queryFn:  () => firestoreService.getDashboardStats(),
  })
}

export function useRecentCards(limit = 5) {
  return useQuery({
    queryKey: dashboardKeys.recentCards(limit),
    queryFn:  async (): Promise<CreditCard[]> => {
      const result = await firestoreService.getCreditCards({}, limit)
      return result.data
    },
  })
}
